<nav class="navbar navbar-dark">
  <div class="container-fluid">
    <a class="navbar-brand cursor-pointer" href="#">
      <img
        src="../../../../../assets/images/Logowebk.svg"
        width="70%"
        alt="{{ 'general.title' | translate }}"
      />
    </a>

    <div class="d-flex flex-1 flex-justify-end flex-align-center gap-1">
      <div *ngIf="!languagePickerDisabled" class="me-1">
        <app-language-picker></app-language-picker>
      </div>

      <ng-container *ngIf="isLoggedIn$ | async">
        <div
          id="hamburger-menu"
          [class.open]="isMenuOpen$ | async"
          (click)="handleToggleHamburgerMenu()"
        >
          <span class="nav-text"></span>
        </div>
      </ng-container>
    </div>
  </div>
</nav>
